export enum Projects {
  CONTROL_PANEL = 'finch-frontend-control',
  ADMIN_PANEL = 'finch-frontend-admin',
  DASHBOARD = 'finch-dashboard',
  QUESTIONNAIRE = 'finch-frontend-questionnaire',
}

export default Projects;
